/** Display only: never use rounded presentation values in ledger calculations. */
export function formatMoney(value:string|number|null|undefined,currency='GBP',fallback='Unknown'){
 if(value==null||typeof value==='string'&&!value.trim())return fallback;
 const number=Number(value);if(!Number.isFinite(number))return fallback;
 return new Intl.NumberFormat('en-GB',{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(number).replace(/^-/, '−');
}
